import equals from 'ramda/src/equals';
import TileType from '~/constants/srp/TileType';
import type { AppliedFilters, ConditionalTile } from '~/contracts/srp';

export type OwnProps = {
  filters: Partial<AppliedFilters>;
};

export default function getSaveSearchTile({
  filters
}: OwnProps): ConditionalTile {
  const active = Object.keys(filters).length > 0 && !equals(filters, {});

  return { active, index: 8, tileType: TileType.SaveSearch };
}
